import { FC, useEffect, useState } from 'react'
import iconTick from '../icons/icon-tick.svg'
import iconCopy from '../icons/icon-copy.svg'
import { getEnv } from './func'

interface NotiItemProps {
  codeClient: string
  nomClient: string
  codeCompany: string
  nomCompany: string
  codeWarehouse: string
  nomWarehouse: string
  onNotiClick: () => void
  quantity: number
  isActive?: boolean
}

const NotiItem: FC<NotiItemProps> = ({
  codeClient,
  nomClient,
  codeCompany,
  nomCompany,
  codeWarehouse,
  nomWarehouse,
  onNotiClick,
  quantity,
  isActive,
}) => {
  const [showCopyBtn, setShowCopyBtn] = useState<boolean>(false)
  const [isCopied, setIsCopied] = useState<boolean>(false)

  const handleClickCopy = (e) => {
    e.stopPropagation()
    if (!isCopied) {
      setIsCopied(true)
    }
    const env = getEnv({
      client_code: codeClient,
      client_nom: nomClient,
      company_code: codeCompany,
      company_nom: nomCompany,
      warehouse_code: codeWarehouse,
      warehouse_nom: nomWarehouse,
    })
    navigator.clipboard.writeText(env)
  }

  useEffect(() => {
    if (!showCopyBtn && isCopied) {
      setIsCopied(false)
    }
  }, [showCopyBtn])

  const showQuantity = quantity > 0
  return (
    <div
      className={`noti-item text-base flex py-1 px-2 ${
        isActive ? 'active' : ''
      }`}
      onClick={onNotiClick}
      onMouseEnter={() => setShowCopyBtn(true)}
      onMouseLeave={() => setShowCopyBtn(false)}
    >
      <div className="flex">
        <div>
          <span className="font-bold">{codeClient}</span>_
          <span className="text-gray">{nomClient}</span> |&nbsp;
          <span className="font-bold">{codeCompany}</span>_
          <span className="text-gray">{nomCompany}</span> |&nbsp;
          <span className="font-bold">{codeWarehouse}</span>_
          <span className="text-gray">{nomWarehouse}</span>
        </div>
        {showQuantity && (
          <>
            <span className="font-bold">
              : <span className="quantity"> {quantity}</span>
            </span>
          </>
        )}
      </div>
      {showCopyBtn && (
        <div className="copy-btn" onClick={handleClickCopy}>
          {isCopied ? (
            <img src={iconTick} alt="tick" />
          ) : (
            <img src={iconCopy} alt="copy" />
          )}
        </div>
      )}
    </div>
  )
}

export default NotiItem
